import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MainApiService from "../../../../../services/mainApi.service";
import { Modal, Table } from "@4uhub/lib4uhub";
import { IQuickAnswer } from "../../../../../models/quick-answer";
import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineRounded";
import { useCallback, useMemo, useState } from "react";
import { QuickAnswerModal } from "../../../../../components/QuickAnswer/QuickAnswerModal/QuickAnswerModal";

const QUICK_ANSWER_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketChannelQuickAnswerAdm/";
const quickAnswerService = new MainApiService<IQuickAnswer>(QUICK_ANSWER_ROUTE);

const translationPath = "page.settings.quickAnswer.";

const QuickAnswerPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const { eI } = useParams();

  const [open, setOpen] = useState(false);

  const [id, setId] = useState<string | null>(null);

  const [refresh, setRefresh] = useState(0);

  const columns: GridColDef<IQuickAnswer>[] = [
    {
      field: "title",
      headerName: t(translationPath + "title") || "Title",
    },
    {
      field: "shortCut",
      headerName: t(translationPath + "shortcut") || "Shortcut",
      maxWidth: 250,
    },
    {
      field: "message",
      headerName: t(translationPath + "message") || "Message",
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<IQuickAnswer>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  const openHandler = useCallback((params: GridRowParams<IQuickAnswer>) => {
    setOpen(true);
    setId(params.row.id);
  }, []);

  const closeHandler = useCallback(() => {
    setOpen(false);
    setId(null);
  }, []);

  const refreshHandler = useCallback(() => {
    setRefresh((prev) => prev + 1);
  }, []);

  const props = useMemo(() => {
    return {
      refresh,
    };
  }, [refresh]);

  return (
    <>
      <QuickAnswerModal
        id={id}
        open={open}
        onClose={closeHandler}
        onRefresh={refreshHandler}
      />
      <Table<IQuickAnswer>
        showDefaultMacroFilters={false}
        service={quickAnswerService}
        serviceProps={props}
        columns={columns}
        title={t(translationPath + "quick_answers")}
        searchInput
        onAdd={handleAdd}
        onRowClick={handleRowClick}
        backButton
        showDeleteButton={false}
        backButtonUrl={`/e/${eI}/dashboard/settings`}
        searchInputPlaceHolder={
          t(translationPath + "search") || "Search for opening hours"
        }
        addButtonLabel={
          t(translationPath + "add") || "Add Protocol Generate Rule"
        }
        rowActions={[
          {
            icon: <RemoveCircleOutlineRoundedIcon color="error" />,
            text: t(translationPath + "inactive_quick_answer"),
            action: openHandler,
          },
        ]}
        confirmOptions={{
          title: t(translationPath + "confirm.title"),
          description: t(translationPath + "confirm.description"),
          confirmationButtonProps: {
            variant: "contained",
          },
        }}
      />
    </>
  );
};

export default QuickAnswerPage;
